import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { siteInfo } from '@/mocks/site';

export default function AboutPage() {
  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `关于我们 - ${siteInfo.name}`,
        url: 'https://51chigua.com/about',
        description: siteInfo.description,
        isPartOf: {
          '@type': 'WebSite',
          name: siteInfo.name,
          url: 'https://51chigua.com',
        },
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://51chigua.com' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      }} />
      <SchemaOrg type="Organization" data={{
        name: siteInfo.name,
        url: 'https://51chigua.com',
        description: siteInfo.description,
        email: siteInfo.contact.email,
        telephone: siteInfo.contact.phone,
        address: {
          '@type': 'PostalAddress',
          streetAddress: siteInfo.contact.address,
          addressCountry: 'CN',
        },
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="px-4 md:px-6 py-8">
            <div className="max-w-5xl mx-auto">
              <Breadcrumb items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]} />

              {/* Brand Intro */}
              <section className="mt-8 mb-14">
                <div className="text-center mb-10">
                  <div className="w-16 h-16 flex items-center justify-center bg-primary-500 rounded-2xl mx-auto mb-4">
                    <i className="ri-fire-line text-background-50 text-2xl"></i>
                  </div>
                  <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">
                    关于{siteInfo.name}
                  </h1>
                  <p className="text-foreground-500 max-w-2xl mx-auto text-sm md:text-base">
                    {siteInfo.tagline}
                  </p>
                </div>

                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-10">
                  <h2 className="font-heading text-xl text-foreground-900 mb-4">品牌故事</h2>
                  <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                    {siteInfo.brandStory}
                  </p>
                </div>
              </section>

              {/* Stats */}
              <section className="mb-14">
                <h2 className="font-heading text-xl text-foreground-900 mb-6 text-center">我们的成绩</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {[
                    { value: siteInfo.stats.dailyVisitors, label: '日均访问量' },
                    { value: siteInfo.stats.totalArticles, label: '累计文章数' },
                    { value: siteInfo.stats.registeredUsers, label: '服务用户数' },
                    { value: `${siteInfo.stats.yearsActive}年`, label: '行业经验' },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
                      <div className="font-heading text-2xl md:text-3xl text-primary-500 mb-1">{stat.value}</div>
                      <div className="text-sm text-foreground-500">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </section>

              {/* FAQ */}
              <section className="mb-14">
                <h2 className="font-heading text-xl text-foreground-900 mb-6 text-center">常见问题</h2>
                <div className="space-y-3">
                  <details className="group bg-background-50 border border-background-200/70 rounded-lg">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-800 font-medium text-sm">
                      {siteInfo.name}是什么？
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {siteInfo.name}是全网领先的娱乐八卦与热点资讯聚合平台，致力于为广大吃瓜群众提供最新、最全、最热的吃瓜资源。我们聚合各类吃瓜内容，包括图文、视频、爆料，一站式满足您的吃瓜需求。
                    </div>
                  </details>
                  <details className="group bg-background-50 border border-background-200/70 rounded-lg">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-800 font-medium text-sm">
                      吃瓜内容多久更新一次？
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      我们的编辑团队全天候追踪全网热点，确保您能在第一时间获取最新吃瓜内容。热门事件发生后的15分钟内即可在我们的平台上看到相关报道。每日精选栏目每天固定更新，为您筛选当日最有价值的吃瓜资源。
                    </div>
                  </details>
                  <details className="group bg-background-50 border border-background-200/70 rounded-lg">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-800 font-medium text-sm">
                      如何联系我们？
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      您可以通过以下方式联系我们：邮箱 {siteInfo.contact.email}，微信 {siteInfo.contact.wechat}，微博 {siteInfo.contact.weibo}。我们会在24小时内回复您的消息。
                    </div>
                  </details>
                </div>
              </section>

              {/* Contact */}
              <section className="mb-14">
                <h2 className="font-heading text-xl text-foreground-900 mb-6 text-center">联系我们</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <div className="space-y-4">
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                          <i className="ri-mail-line text-lg"></i>
                        </span>
                        <div>
                          <p className="text-xs text-foreground-400">邮箱</p>
                          <p className="text-sm text-foreground-800">{siteInfo.contact.email}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                          <i className="ri-wechat-line text-lg"></i>
                        </span>
                        <div>
                          <p className="text-xs text-foreground-400">微信</p>
                          <p className="text-sm text-foreground-800">{siteInfo.contact.wechat}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                          <i className="ri-weibo-line text-lg"></i>
                        </span>
                        <div>
                          <p className="text-xs text-foreground-400">微博</p>
                          <p className="text-sm text-foreground-800">{siteInfo.contact.weibo}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 flex-shrink-0">
                          <i className="ri-phone-line text-lg"></i>
                        </span>
                        <div>
                          <p className="text-xs text-foreground-400">电话</p>
                          <p className="text-sm text-foreground-800">{siteInfo.contact.phone}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <form
                      id="contact-form"
                      data-readdy-form
                      className="space-y-4"
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const form = e.currentTarget;
                        const honeypotInput = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
                        if (honeypotInput && honeypotInput.value.trim()) {
                          alert('消息已发送，我们会尽快回复！');
                          form.reset();
                          return;
                        }
                        try {
                          const formData = new FormData(form);
                          formData.delete('website_alt');
                          const urlSearchParams = new URLSearchParams();
                          formData.forEach((value, key) => {
                            urlSearchParams.append(key, value as string);
                          });
                          const res = await fetch('https://readdy.ai/api/form/d9oqmbiftmtnfcfh0cf0', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: urlSearchParams.toString(),
                          });
                          if (res.ok) {
                            alert('消息已发送，我们会尽快回复！');
                            form.reset();
                          } else {
                            alert('发送失败，请稍后重试或直接发送邮件联系我们。');
                          }
                        } catch {
                          alert('发送失败，请稍后重试或直接发送邮件联系我们。');
                        }
                      }}
                    >
                      <div>
                        <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-1.5">
                          姓名 <span className="text-primary-500">*</span>
                        </label>
                        <input
                          id="contact-name"
                          name="name"
                          type="text"
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-1.5">
                          邮箱 <span className="text-primary-500">*</span>
                        </label>
                        <input
                          id="contact-email"
                          name="email"
                          type="email"
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-1.5">
                          留言 <span className="text-primary-500">*</span>
                        </label>
                        <textarea
                          id="contact-message"
                          name="message"
                          required
                          maxLength={500}
                          rows={4}
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                          placeholder="请输入您的留言（500字以内）"
                        ></textarea>
                      </div>
                      <input
                        type="text"
                        name="website_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                        className="honeypot-field"
                      />
                      <button
                        type="submit"
                        className="w-full px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        发送消息
                      </button>
                    </form>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}